import React from "react";
import { useState, useEffect} from "react";
import BSFImage from "../../../Assets/bfsi.png"
import CoreBankingGif from '../../../Assets/core_banking.gif'
import SoftwareTestingGif from '../../../Assets/software_testing.gif'
import MobileAppGif from '../../../Assets/mobile_applications.gif'
import { ShieldCheck, Database, TrendingUp, Lock, Code, Users, Globe, Zap, Brain, Cloud , Shield, Check} from 'lucide-react';
import { ArrowRight,Phone } from "lucide-react";
import { Helmet } from 'react-helmet';


const Bsfi = () => {
    


  const whyChoose = [
    {
      title: "Proven BFSI Expertise",
      description:
        "Proven experience across banking, insurance, lending, and capital markets with deep industry knowledge",
      icon: ShieldCheck,
      gradient: "linear-gradient(to right, #3b82f6, #06b6d4)", // blue-500 → cyan-500
    },
    {
      title: "Seamless Integration",
      description:
        "Deep integration capabilities with CRMs, ERPs, and core BFSI platforms for unified operations",
      icon: Database,
      gradient: "linear-gradient(to right, #10b981, #14b8a6)", // emerald-500 → teal-500
    },
    {
      title: "Certified Talent",
      description:
        "Certified professionals across cloud, data, security, and AI/ML technologies for premium delivery",
      icon: Users,
      gradient: "linear-gradient(to right, #8b5cf6, #ec4899)", // purple-500 → pink-500
    },
    {
      title: "Agile Delivery",
      description:
        "Agile delivery frameworks and DevOps for faster go-to-market and continuous innovation",
      icon: Zap,
      gradient: "linear-gradient(to right, #f97316, #ef4444)", // orange-500 → red-500
    },
    {
      title: "Global Support",
      description:
        "Global delivery model with 24/7 support and flexible engagement models for business continuity",
      icon: Globe,
      gradient: "linear-gradient(to right, #6366f1, #3b82f6)", // indigo-500 → blue-500
    },
  ];

  const features = [
    {
      title: "Core Banking",
      items: [
        "Centralized banking operations",
        "Digital payments & UPI integrations",
        "Loan & deposit management",
        "Compliance & security"
      ],
      gradient: "linear-gradient(135deg, #3b82f6, #06b6d4)",
      dotColor: "#3b82f6",
      gif: CoreBankingGif
    },
    {
      title: "Software Testing",
      items: [
        "Functional & regression testing",
        "Security testing (BFSI-grade)",
        "Automation frameworks",
        "Performance & scalability testing"
      ],
      gradient: "linear-gradient(135deg, #059669, #14b8a6)",
      dotColor: "#059669",
      gif: SoftwareTestingGif
    },
    {
      title: "App Development",
      items: [
        "Mobile banking apps (iOS/Android)",
        "Financial service portals",
        "Cloud-native development",
        "AI & analytics integration"
      ],
      gradient: "linear-gradient(135deg, #8b5cf6, #ec4899)",
      dotColor: "#8b5cf6",
      gif: MobileAppGif
    }
  ];

    const icons = [Brain, Globe, Cloud, ShieldCheck, Code, Users];

    const [isVisible, setIsVisible] = useState(false);

      useEffect(() => {
        setIsVisible(true);
    }, []);

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>PTKCS Tech | Banking, Financial Services & Insurance (BSFI) – Transforming Financial Operations with Technology</title>
        <meta 
          name="description" 
          content="PTKCS Tech offers specialized ERP solutions for the Banking, Financial Services, and Insurance (BSFI) sector, focusing on enhancing operational efficiency, ensuring regulatory compliance, and driving digital transformation. Our expertise in platforms like Infor LN, M3, and Syteline empowers financial institutions to optimize processes and deliver superior services." 
        />
        <meta 
          name="keywords" 
          content="BSFI ERP solutions, banking ERP, financial services ERP, insurance ERP, Infor LN, Infor M3, Infor Syteline, financial digital transformation, regulatory compliance, PTKCS Tech, financial operations optimization" 
        />
        
        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PTKCS Tech" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>


    <div className="min-h-screen" style={{ backgroundColor: "#ffffff" }}>
      
    {/* Hero Section */}
    <section 
      className="relative py-16 md:py-32  overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0e172cff 100%)'
      }}
    >
      {/* Grid pattern overlay */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `
            linear-gradient(rgb(59, 130, 246) 1px, transparent 1px),
            linear-gradient(90deg, rgb(59, 130, 246) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}
      ></div>

      {/* Main content */}
      <div className="relative z-10 flex items-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto w-full">
          <div className="flex flex-col lg:flex-row items-center gap-10">
            {/* Left content */}
            <div className="lg:w-1/2 text-center lg:text-left">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                Transforming Banking & Financial Services
                <span 
                  className="block text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight"
                  style={{ color: '#0891b2' }}
                >
                  with Technology
                </span>
              </h1>
              
              <p style={{ color: '#bdb6b6ff' }} className="text-base sm:text-lg text-slate-300 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                We empower BFSI institutions with modern core banking solutions, quality software testing, 
                and cutting-edge app development to drive digital transformation.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 sm:gap-6">
                <button 
                  className="group font-semibold px-6 sm:px-8 py-3 sm:py-4 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl flex items-center gap-2"
                  style={{
                    background: 'linear-gradient(90deg, #0891b2, #059669)',
                    color: 'white'
                  }}
                >
                  Get Started
                  <ArrowRight className="w-4 sm:w-5 h-4 sm:h-5 group-hover:translate-x-1 transition-transform" />
                </button>
                
                <button 
                  className="group border-2 font-semibold px-6 sm:px-8 py-3 sm:py-4 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg flex items-center gap-2"
                  style={{
                    borderColor: '#475569',
                    color: 'white'
                  }}
                >
                  <Phone className="w-4 sm:w-5 h-4 sm:h-5" />
                  Contact Us
                </button>
              </div>
            </div>

            {/* Right image */}
            <div className="lg:w-1/2 flex justify-center">
              <div 
                className="relative w-full max-w-md rounded-xl overflow-hidden shadow-xl"
                style={{
                  background: 'linear-gradient(135deg, #1e3a8a 0%, #0c4a6e 100%)',
                  height: '380px'
                }}
              >
                <img
                  src={BSFImage}
                  alt="Digital Banking Technology"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      {/* Why Choose Us */}
    <section
      className="py-20"
      style={{
        background: "linear-gradient(to bottom right, #f8fafc, #f1f5f9)", // from-slate-50 to-slate-100
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2
            className="text-3xl md:text-4xl font-bold mb-6 bg-clip-text text-transparent"
            style={{
              backgroundImage: "linear-gradient(to right, #1e293b, #475569)", // slate-800 → slate-600
            }}
          >
            Why Choose <span className="text-3xl md:text-4xl font-bold mb-6 bg-clip-text text-transparent" style={{color:'#dd590cff'}}>PTKCS </span>for Your BFSI Technology Needs?
          </h2>
          <p
            className="text-xl max-w-4xl mx-auto leading-relaxed"
            style={{ color: "#475569" }} // slate-600
          >
            Let PTKCS be your technology and staffing partner as you lead the
            future of digital finance.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChoose.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border"
                style={{
                  borderColor: "#e2e8f0", // slate-200
                  backgroundColor: "#ffffff", // white
                }}
              >
                {/* Icon with gradient background */}
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-6 shadow-lg"
                  style={{
                    backgroundImage: item.gradient,
                    color: "#ffffff",
                  }}
                >
                  <Icon className="w-7 h-7" />
                </div>

                {/* Title */}
                <h3
                  className="text-xl font-semibold mb-3"
                  style={{ color: "#1e293b" }} // slate-800
                >
                  {item.title}
                </h3>

                {/* Description */}
                <p
                  className="leading-relaxed"
                  style={{ color: "#475569" }} // slate-600
                >
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>

    {/*Shedule Section*/}
    <section 
      className="py-20"
      style={{ 
        background: 'linear-gradient(135deg, #8b5cf6, #d946ef)' 
      }}
    >
      <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 leading-tight">
          Let’s Build the Future of Banking Together
        </h2>
        <div className="pt-4">
          <button 
            className="font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            style={{ 
              backgroundColor: 'white', 
              color: '#8b5cf6' 
            }}
          >
            Schedule a Demo
          </button>
        </div>
      </div>
    </section>

    {/* Core Features Section */}
    <section style={{ backgroundColor: '#f9fafb' }} className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#111827' }}>
            Core Features of Our <span className="inline-block relative">
              <span className="font-extrabold text-3xl md:text-4xl" style={{ 
                backgroundImage: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                color: 'transparent',
                letterSpacing: '-0.01em'
              }}>BFSI</span>
              <svg className="absolute -bottom-1 left-0 w-full" viewBox="0 0 100 10" preserveAspectRatio="none">
                <path d="M0,5 Q25,0 50,5 T100,5" stroke="url(#gradient)" strokeWidth="2" fill="none" />
              </svg>
              <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 100 10" preserveAspectRatio="none">
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#3b82f6" />
                    <stop offset="100%" stopColor="#8b5cf6" />
                  </linearGradient>
                </defs>
              </svg>
            </span> Solutions
          </h2>
          <p style={{ color: '#4b5563' }} className="text-xl max-w-3xl mx-auto">
            Our main offerings designed to transform your financial technology landscape
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 p-8 relative overflow-hidden group"
            >
              {/* Custom Border Effect - Only border animates on hover */}
              <div className="absolute top-0 left-0 transition-all duration-300 group-hover:w-1/2 group-hover:h-1/2 w-1/5 h-1/5">
                <div className="w-full h-full border-l-4 border-t-4 group-hover:border-l-6 group-hover:border-t-6" style={{ color: '#ffa31a' }}></div>
              </div>
              <div className="absolute bottom-0 right-0 transition-all duration-300 group-hover:w-1/2 group-hover:h-1/2 w-1/5 h-1/5">
                <div className="w-full h-full border-r-4 border-b-4 group-hover:border-r-6 group-hover:border-b-6" style={{ color: '#ffa31a'  }}></div>
              </div>
              
              <div className="relative z-10">
                <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                  <img 
                    src={feature.gif} 
                    alt={feature.title}
                    className="w-14 h-14 rounded-lg"
                  />
                </div>
                
                <h3 style={{ color: feature.gradient }} className="text-2xl font-bold mb-6">{feature.title}</h3>
                
                <ul className="space-y-4">
                  {feature.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start">
                      <div className="flex-shrink-0 mt-1">
                        <div 
                          className="w-2 h-2 rounded-full"
                          style={{ backgroundColor: feature.dotColor }}
                        ></div>
                      </div>
                      <span style={{ color: '#4b5563' }} className="ml-3 leading-relaxed">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </div>
  </>
  );
};

export default Bsfi;
